<!-- Menu trigger -->
<button 
  *ngIf="authService.canCreate('module') || authService.canCreate('submodule') || authService.canCreate('element')"
  mat-flat-button color="primary" 
  [matMenuTriggerFor]="projectInfoAddEntityMenu">
  {{ 'add' | translate }}
</button>

<!-- Main menu -->
<mat-menu #projectInfoAddEntityMenu="matMenu">
  <ng-template matMenuContent>

    <button mat-menu-item 
      (click)="addModule()"
      [disabled]="!authService.canCreate('module')">
      <mat-icon>add</mat-icon>
      {{ 'addmodule' | translate }}
    </button>

    <!-- <button mat-menu-item 
      (click)="addSubmodule()"
      [disabled]="!authService.canCreate('submodule')">
      <mat-icon>add</mat-icon>
      {{ 'submoduleAdd' | translate }}
    </button>

    <button mat-menu-item 
      (click)="addElement()"
      [disabled]="!authService.canCreate('element')">
      <mat-icon>add</mat-icon>
      {{ 'specificationAdd' | translate }}
    </button> -->

  </ng-template>
</mat-menu>